// Kiosk auth store with localStorage persistence
// Persists the device token so Workshop Recall auto-reconnects on reload
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AuthStore {
  /** Bearer token issued by /api/kiosk/pair -- null when unpaired */
  kioskToken: string | null;
  /** Display name of the workshop this device is paired to */
  workshopName: string | null;
  /** True when a valid kioskToken is stored */
  isPaired: boolean;

  /** Called on successful pairing -- stores token + workshop name */
  setPaired: (token: string, workshopName: string) => void;
  /** Called on 401 from server or manual unpair -- clears all auth state */
  clearAuth: () => void;
}

export const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      kioskToken: null,
      workshopName: null,
      isPaired: false,

      setPaired: (token, workshopName) =>
        set({ kioskToken: token, workshopName, isPaired: true }),

      clearAuth: () =>
        set({ kioskToken: null, workshopName: null, isPaired: false }),
    }),
    {
      name: 'ventura-machina-auth',
    }
  )
);
